export class UdfGroupResponseResult {
  Groups: UdfGroup[];
}

export class UdfGroup {
  Name: string;
  Description: string;
}
